import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from "@angular/core";
import { SearchBoxConfig } from "@spartacus/storefront";


@Component({
    selector: 'app-return-search',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './return-search.component.html',
    styleUrls: ['./return-search.component.scss'],
    standalone: false
})
export class ReturnSearchComponent implements OnInit {
  @Output() selectedProductEvent = new EventEmitter<any>();
  clearSearchValue = false;
  QUICKORDER_SEARCH_BOX_CONFIG: SearchBoxConfig = {
    minCharactersBeforeRequest: 3,
    displayProducts: true,
    displaySuggestions: false,
    displayProductImages: false,
  };
  placeholderText = 'Search vaccines to return';
  constructor() { }

  ngOnInit(): void { }
  onProductSelected(product) {




    this.selectedProductEvent.emit(product);
  }
}
